module.exports = __webpack_public_path__ + "img/success.e57c86ff.svg";